/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Performancereport_Totalreturn3Inputs */

const en_coinvestments_performancereport_totalreturn3 = /** @type {(inputs: Coinvestments_Performancereport_Totalreturn3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total return (MOIC)`)
};

/**
* | output |
* | --- |
* | "Total return (MOIC)" |
*
* @param {Coinvestments_Performancereport_Totalreturn3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_performancereport_totalreturn3 = /** @type {((inputs?: Coinvestments_Performancereport_Totalreturn3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Performancereport_Totalreturn3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_performancereport_totalreturn3(inputs)
});
export { coinvestments_performancereport_totalreturn3 as "coInvestments_performanceReport_totalReturn" }